// ⚠️  AUTO-GENERATED — DO NOT EDIT
// Source: tokens/tokens.json
// Generated by: npm run build:tokens

export const ADMIN_COLORS = {
  "bg": "#0E0F11",
  "surface": "#141517",
  "card": "#1C1E22",
  "elevated": "#282A2F",
  "border": "whiteAlpha.100",
  "borderSubtle": "whiteAlpha.200",
  "borderMedium": "whiteAlpha.300",
  "textPrimary": "whiteAlpha.900",
  "textSecondary": "charcoal.100",
  "textLabel": "charcoal.200",
  "textMuted": "charcoal.300",
  "textGhost": "whiteAlpha.500",
  "hoverBg": "whiteAlpha.100",
  "hoverBorder": "whiteAlpha.400",
  "activeBg": "whiteAlpha.200",
  "selectedBg": "whiteAlpha.50",
  "selectedAccentBg": "rgba(255,90,44,0.08)",
  "overlay": "blackAlpha.600",
  "overlayDense": "blackAlpha.700",
  "overlayOpaque": "blackAlpha.800",
  "accent": "blaze.blaze",
  "brand": "#FF5A2C",
  "shadowMd": "0 8px 32px rgba(0,0,0,0.4)",
  "shadowDrag": "0 20px 50px rgba(0,0,0,0.6), 0 0 0 1px rgba(251,146,60,0.4)"
} as const;

export const ADMIN_LAYOUT = {
  "pagePx": {
    "base": 4,
    "md": 6
  },
  "pagePy": 6,
  "sectionGap": 6,
  "cardPadding": 5,
  "itemGap": 4,
  "radius": "lg",
  "radiusSm": "md",
  "minContentH": "calc(100vh - 240px)",
  "drawerWidth": "480px",
  "inputProps": {
    "bg": "#1C1E22",
    "borderColor": "whiteAlpha.300",
    "_hover": {
      "borderColor": "whiteAlpha.400"
    },
    "_focus": {
      "borderColor": "blaze.blaze",
      "boxShadow": "none"
    }
  },
  "tabProps": {
    "variant": "soft-rounded",
    "size": "sm",
    "colorScheme": "orange"
  },
  "tabItemProps": {
    "fontSize": "xs",
    "fontWeight": "600",
    "px": 3,
    "py": 1,
    "color": "whiteAlpha.500",
    "_selected": {
      "color": "white",
      "bg": "whiteAlpha.200"
    },
    "_hover": {
      "color": "whiteAlpha.800"
    }
  },
  "tabUnderlineProps": {
    "variant": "unstyled",
    "size": "sm"
  },
  "tabUnderlineItemProps": {
    "fontSize": "sm",
    "fontWeight": "600",
    "px": 3,
    "py": 1.5,
    "color": "charcoal.200",
    "borderBottom": "2px solid",
    "borderColor": "transparent",
    "mb": "-1px",
    "transition": "all 0.15s",
    "_selected": {
      "color": "white",
      "borderColor": "blaze.blaze"
    },
    "_hover": {
      "color": "whiteAlpha.800"
    }
  },
  "tabUnderlineListProps": {
    "borderBottom": "1px solid",
    "borderColor": "whiteAlpha.100",
    "gap": 0
  }
} as const;

export const ADMIN_MOTION = {
  "duration": {
    "fast": "100ms",
    "normal": "150ms",
    "slow": "300ms"
  },
  "easing": {
    "default": "cubic-bezier(0.4, 0, 0.2, 1)",
    "enter": "cubic-bezier(0, 0, 0.2, 1)",
    "exit": "cubic-bezier(0.4, 0, 1, 1)",
    "bounce": "cubic-bezier(0.68, -0.55, 0.265, 1.55)"
  }
} as const;

export const Z_INDEX = {
  "content": 0,
  "stickyHeader": 10,
  "dropdown": 20,
  "sidebar": 30,
  "drawer": 40,
  "modal": 50,
  "overlay": 60,
  "popover": 70,
  "toast": 80,
  "devTools": 90
} as const;

export const SHADOWS = {
  "md": "0px 8px 32px 0px #00000066",
  "drag": "0px 20px 50px 0px #00000099, 0px 0px 0px 1px #FB923C66",
  "tooltip": "0px 8px 32px 0px #00000066, 0px 2px 8px 0px #00000033, inset 0px -1px 0px 0px #FFFFFF0D",
  "infoTooltip": "0px 18px 48px 0px #0000007A, inset 0px -1px 0px 0px #FFFFFF14",
  "glow.success": "0px 0px 0px 1px #48BB7859, 0px 8px 24px 0px #48BB7824",
  "glow.warning": "0px 0px 0px 1px #F6AD5552, 0px 8px 24px 0px #F6AD551F",
  "glow.error": "0px 0px 0px 1px #FC818159, 0px 8px 24px 0px #FC818124"
} as const;

export const CHART_THEME = {
  "tooltipBg": "#141517",
  "tooltipBorder": "1px solid rgba(255,255,255,0.1)",
  "tooltipRadius": "8px",
  "tooltipColor": "#fff",
  "tooltipFontSize": 12,
  "tickFill": "#727374",
  "tickFontSize": 11,
  "gridStroke": "rgba(255,255,255,0.05)",
  "axisStroke": "rgba(255,255,255,0.1)",
  "cellStroke": "rgba(0,0,0,0.3)",
  "legendFontSize": 12,
  "legendColor": "#727374"
} as const;

export const CHART_COLORS = [
  "#BC3CFF",
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#06B6D4",
  "#8B5CF6",
  "#EC4899"
] as const;
